import React, { useState } from 'react';
import { Modal } from 'antd';
import { translate } from '@portal/services/i18n';
import AdvancedButton from '@portal/components/AdvancedButton/AdvancedButton';
import CurrencyInputMask from 'react-currency-input';

type IProps = {
  visible: boolean;
  onCloseModal: () => void;
  onHandleUpdate: (rawValue: number) => void;
  title: string;
};

const LimitPixModal: React.FC<IProps> = ({
  visible,
  onCloseModal,
  onHandleUpdate,
  title,
}: IProps) => {
  const [amount, setAmount] = useState('0');
  const [rawAmount, setRawAmount] = useState(0);

  const handleCloseModal = () => {
    onCloseModal();
    setAmount('0');
    setRawAmount(0);
  };

  const handleConfirm = () => {
    onHandleUpdate(rawAmount);
    handleCloseModal();
  };

  return (
    <Modal
      title={title}
      open={visible}
      onCancel={() => handleCloseModal()}
      footer={[
        <div
          className="popup-modal__footer d-flex justify-content-end"
          key={title}
        >
          <AdvancedButton
            type="button"
            key="upload"
            text={translate(`SHARED.CANCEL`)}
            onClick={() => handleCloseModal()}
          />
          <div className="popup-modal__footer__button ml-3">
            <AdvancedButton
              type="button"
              key="upload"
              text={translate(`SHARED.CONFIRM`)}
              onClick={() => handleConfirm()}
            />
          </div>
        </div>,
      ]}
    >
      <div className="limit-pix-modal">
        <CurrencyInputMask
          className="limit-pix-modal__currency-mask-input"
          autoFocus
          value={amount}
          onChange={(value, rawValues) => {
            setRawAmount(rawValues ?? 0);
            setAmount(value ?? '0');
          }}
          decimalSeparator={translate('SHARED.CURRENCY.DECIMAL_SEPARATOR')}
          thousandSeparator={translate('SHARED.CURRENCY.THOUSAND_SEPARATOR')}
          prefix={translate('SHARED.CURRENCY.SYMBOL')}
        />
      </div>
    </Modal>
  );
};

export default LimitPixModal;
